import { render } from "./GenericPacket.vue?vue&type=template&id=077bc2c9&scoped=true&ts=true"
import script from "./GenericPacket.vue?vue&type=script&lang=ts"
export * from "./GenericPacket.vue?vue&type=script&lang=ts"

import "./GenericPacket.vue?vue&type=style&index=0&id=077bc2c9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077bc2c9"]])

export default __exports__